"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const antipromesas = [{
  titulo: "No revendemos licencias ni hacemos markup en software.",
  detalle: "El cliente paga lo que cuesta el software, directo al proveedor. Nuestra utilidad viene del servicio, no del intermediario."
}, {
  titulo: "No automatizamos sin diagnóstico previo.",
  detalle: "Si no entendimos el proceso, no proponemos arquitectura. Saltarse esta fase es la causa más común de implementaciones que no rinden."
}, {
  titulo: "No entregamos cajas negras.",
  detalle: "Cada activo que construimos viene con documentación que cualquier ingeniero puede leer y mantener. Si decides operar in-house mañana, adelante."
}, {
  titulo: "No facturamos por hora.",
  detalle: "Facturamos por valor instalado. Si una herramienta nos hace cinco veces más rápidos, el beneficio queda con el cliente, no se diluye en la factura."
}, {
  titulo: "No proponemos IA cuando un script de doce líneas resuelve.",
  detalle: "Las modas pasan. El criterio no."
}];
export default function AntiPromesas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="sobre-antipromesas" id="lo-que-no-hacemos" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-6">
            Lo que no hacemos.
          </h2>

          <p className="font-sans text-lg text-muted-foreground leading-relaxed max-w-2xl">
            La forma más clara de explicar a qué se compromete Fulcro es nombrar lo que rechaza.
          </p>
        </div>

        <div className="space-y-12">
          {antipromesas.map((antipromesa, i) => <AntiPromesaItem key={i} antipromesa={antipromesa} index={i} />)}
        </div>
      </div>
    </section>;
}
function AntiPromesaItem({
  antipromesa,
  index
}: {
  antipromesa: {
    titulo: string;
    detalle: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <h3 className="font-serif text-2xl md:text-3xl text-foreground font-normal leading-tight mb-3">
        {antipromesa.titulo}
      </h3>
      <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl">
        {antipromesa.detalle}
      </p>
    </div>;
}